import { render, staticRenderFns } from "./ExamPropertiesMenu.vue?vue&type=template&id=6a4d265f"
import script from "./ExamPropertiesMenu.vue?vue&type=script&lang=js"
export * from "./ExamPropertiesMenu.vue?vue&type=script&lang=js"
import style0 from "./ExamPropertiesMenu.vue?vue&type=style&index=0&id=6a4d265f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports